var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slogan"},[_c('div',{staticClass:"text"},[_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","align-items":"center"}},[_c('platforms')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }